import { accessorialWithBackupDocumentsExcluded, OTHER } from 'config/documents';
import { FEATURE_FLAG_ENABLED_BREADCRUMB } from 'constants/temp-feature-flag-breadcrumb';
import { sluggify } from 'utils/localization/utils';
export const getUniqueRequiredAccessorialDocuments = (accessorialDocsRules, carrierDocumentsMapResults) => {
    // if SSR and Carrier rules overlap -> this removes duplicates
    const allAccessorialDocsRequired = FEATURE_FLAG_ENABLED_BREADCRUMB
        ? accessorialDocsRules.concat(carrierDocumentsMapResults)
        : accessorialDocsRules;
    const accessorialDocs = {};
    allAccessorialDocsRequired.forEach((doc) => {
        accessorialDocs[doc.value] = {
            value: doc.value,
            slug: doc.value,
            name: doc.name,
            file: null,
        };
    });
    return Object.values(accessorialDocs);
};
const getBackupDocumentName = (accessorialTypeName) => {
    const GENERIC_SUFFIX_NAME = 'Backup';
    return `${accessorialTypeName} ${GENERIC_SUFFIX_NAME}`;
};
export const getBackupDocumentSlug = (accessorialTypeSlug) => {
    if (FEATURE_FLAG_ENABLED_BREADCRUMB) {
        const GENERIC_SUFFIX_SLUG = 'BACKUP';
        const backupAccessorialSlug = `${accessorialTypeSlug}_${GENERIC_SUFFIX_SLUG}`;
        return sluggify(backupAccessorialSlug);
    }
};
export const formatBackupDocuments = (accessorialTypeName, accessorialTypeSlug, requiredDocs) => {
    if (FEATURE_FLAG_ENABLED_BREADCRUMB) {
        const mappedRequiredDocs = requiredDocs
            // CARGO-10868 - exclude backup docs for selected doc types
            .filter((requiredDoc) => {
            if (requiredDoc.value === OTHER.value &&
                accessorialWithBackupDocumentsExcluded.includes(accessorialTypeSlug)) {
                return false;
            }
            return true;
        })
            .map((requiredDoc) => {
            if (requiredDoc.value !== OTHER.value) {
                return requiredDoc;
            }
            else {
                return Object.assign(Object.assign({}, requiredDoc), { slug: getBackupDocumentSlug(accessorialTypeSlug), name: getBackupDocumentName(accessorialTypeName) });
            }
        });
        return mappedRequiredDocs;
    }
    return requiredDocs;
};
